<template>
  <div>
    <FilterOrganization :disabled="false" @option="onOptionChange" :option="option"/>
    <History class="mb-3" :disable="true" :caption="$t('reportStatus')" :item="item" :pages="pages" :loading="loading" :fields="fields" :childrenFields="childrenFields" />
    <ReportCompetency class="mb-3" :item="organizations" :loading="loading1"/>
    <History class="mb-3" :caption="$t('reportCompetency')" small :item="item1"  :loading="loading1" :is-hris="false" />
<!--    <AssessmentSummary class="mb-3" :caption="$t('reportCompetency')" small :item="item1"  :loading="loading1" />-->

  </div>
</template>

<script>
import Service from "@/service/api";
import {mapGetters} from "vuex";
import History from "@/projects/views/E-Performances/Dashboard/Admin/components/Historys";
import ReportCompetency from "@/projects/views/E-Performances/Dashboard/Admin/components/ReportCompetency";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization.vue";

export default {
  name: "index",
  components: {FilterOrganization, ReportCompetency, History},
  data: function () {
    return {
      pages: {
        values: [100, 200, 500, 1000, 2000]
      },
      option: {
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 543,
      },

      loading: true,
      item: [],
      fields: [
        {key: "index", label: "#", _style: 'width:50px; text-align: center'},
        {key: "code", label: "Code", _style: 'width:30px; text-align: center'},
        {key: "title", label: "Title"},
        {key: "total", label: "Total", _style: 'width:150px; text-align: center'},
        {key: "completed", label: "Completed", _style: 'width:150px; text-align: center'},
        {key: "doing", label: "Doing", _style: 'width:150px; text-align: center'},
        {key: "pending", label: "Pending", _style: 'width:150px; text-align: center'},
        {key: "action", label: "#", _style: 'width:30px; text-align: center'}
      ],
      childrenFields: [
        {key: "index", label: "#", _style: 'width:50px; text-align: center'},
        {key: "code", label: "Code", _style: 'width:30px; text-align: center'},
        {key: "info", label: "Name"},
        {key: "competencyLevel", label: "level"},
        {key: "assessor1", label: "Assessor 1"},
        {key: "assessor2", label: "Assessor 2"},
        {key: "status", label: "Status"},
        {key: "action", label: "#", _style: 'width:30px; text-align: center'}
      ],

      organizations: [],

      loading1: true,
      item1: [],
      loadDebounceId: null,
    }

  },

  created () {
    this.onInit()

  },

  beforeDestroy() {
    clearTimeout(this.loadDebounceId);
  },

  methods: {
    async onInit() {
      await this.syncLatestReportYear();
      this.onLoad();
    },

    onLoad() {
      if (this.$store.getters["personal/profile"].role === 0) {
        this.loading = false;
        this.loading1 = false;
        return;
      }

      this.loading = true;
      this.loading1 = true;

      const body = this.createRequestBody();
      this.$store.dispatch("estimate/reportsStatus", body)
      this.$store.dispatch("estimate/reportsGroups", body)
    },

    onOptionChange(option) {
      this.option = {...option};
      this.scheduleLoad();
    },

    scheduleLoad() {
      clearTimeout(this.loadDebounceId);
      this.loadDebounceId = setTimeout(() => {
        this.onLoad();
      }, 250);
    },

    async syncLatestReportYear() {
      try {
        const response = await Service.estimatesAssessment('report-years', {}, { timeout: 15000 });
        const years = Array.isArray(response?.data?.data) ? response.data.data : [];
        if (years.length > 0) {
          this.option.year = years[0];
        }
      } catch (error) {
        console.error("[dashboard/admin] failed to load report years", error?.message || error);
      }
    },

    createRequestBody() {
      const profile = this.$store.getters["personal/profile"];
      const body = {
        group: true,
        organization: this.option.organization,
        year: parseInt(this.option.year, 10),
      };

      if (this.option.agency && this.option.agency !== 0) {
        body.agency = this.option.agency;
      }

      if (profile.role !== 1 && profile.agency && profile.agency._id) {
        body.agency = profile.agency._id;
      }

      return body;
    },

    getLocalizedTitle(titles) {
      if (!Array.isArray(titles) || titles.length === 0) {
        return "-";
      }

      const localizedTitle = titles.find((entry) => entry.key === this.lang);
      return (localizedTitle || titles[0] || {}).value || "-";
    },

    mapStatusReports(reports) {
      return (reports || []).map((report, _index, list) => ({
        code: report.code,
        title: this.getLocalizedTitle(report.title),
        total: Array.isArray(report.item) ? report.item.length : 0,
        completed: report.completed || 0,
        doing: report.doing || 0,
        pending: report.pending || 0,
        item: Array.isArray(report.item) ? report.item : [],
        _toggled: list.length === 1 ? true : !!report._toggled,
      }));
    },

    mapGroupReports(reports) {
      return (reports || []).map((report, _index, list) => ({
        ...report,
        title: this.getLocalizedTitle(report.title),
        total: Array.isArray(report.item) ? report.item.length : 0,
        explorerAgency: (report.explorerAgency || []).map((entry) => ({
          ...entry,
          title: this.getLocalizedTitle(entry.title),
        })),
        _toggled: list.length === 1 ? true : !!report._toggled,
      }));
    },

    buildOrganizationsSummary(reports) {
      const mergedData = reports.reduce((summary, report) => {
        (report.explorerAgency || []).forEach((entry) => {
          if (!summary[entry.title]) {
            summary[entry.title] = {
              title: entry.title,
              complete: 0,
              total: 0,
              isGap: 0,
              isMeets: 0,
              isExceeding: 0,
            };
          }

          summary[entry.title].total += report.member || 0;
          summary[entry.title].complete += entry.total || 0;
          summary[entry.title].isGap += entry.isGap || 0;
          summary[entry.title].isMeets += entry.isMeets || 0;
          summary[entry.title].isExceeding += entry.isExceeding || 0;
        });

        return summary;
      }, {});

      return Object.values(mergedData);
    },

    syncStatusReports(reports) {
      this.item = this.mapStatusReports(reports);
      this.loading = false;
    },

    syncGroupReports(reports) {
      const mappedReports = this.mapGroupReports(reports);
      this.organizations = this.buildOrganizationsSummary(mappedReports);
      this.item1 = mappedReports;
      this.loading1 = false;
    },

  },

  computed:{
    ...mapGetters({
      lang : "setting/lang",
      reportsStatus: 'estimate/reportsStatus',
      reportsGroup: 'estimate/reportsGroup',

      isReload: 'assessment/isReload'
    }),
  },

  watch: {
    lang() {
      this.syncStatusReports(this.reportsStatus);
      this.syncGroupReports(this.reportsGroup);
    },
    reportsStatus(value) {
      this.syncStatusReports(value);
    },
    reportsGroup(value) {
      this.syncGroupReports(value);
    },

    isReload(value) {
      if (value == true) {
        clearTimeout(this.loadDebounceId)
        this.onLoad()
        this.$store.commit("assessment/isReload", false)
      }
    }
  }

}
</script>

<style scoped>

</style>
